import React from "react";

import { Table, Popup } from "semantic-ui-react";

import * as moment from "moment";

const TransactionRow = props => {
  const transaction = props.transaction;
  const amount = transaction.amount;
  return (
    <Table.Row>
      <Table.Cell>{transaction.name}</Table.Cell>
      <Table.Cell>{+amount >= 0 ? "$" + amount : ""}</Table.Cell>
      <Table.Cell>{+amount < 0 ? "$" + (-amount).toFixed(2) : ""}</Table.Cell>
      <Table.Cell>
        <Popup
          inverted
          trigger={
            <span>
              {moment(transaction.date).calendar(null, {
                sameDay: "[Today]",
                lastDay: "[Yesterday]",
                lastWeek: "[Last] dddd",
                sameElse: "L"
              })}
            </span>
          }
        >
          {moment(transaction.date).format("LL")}
        </Popup>
      </Table.Cell>
      <Table.Cell>****{transaction.account.mask}</Table.Cell>
    </Table.Row>
  );
};

const TransactionTable = props => {
  return (
    <Table celled selectable={props.transactions.length !== 0} compact>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell width={10}>Description</Table.HeaderCell>
          <Table.HeaderCell width={1}>Spent</Table.HeaderCell>
          <Table.HeaderCell width={1}>Received</Table.HeaderCell>
          <Table.HeaderCell width={2}>Date</Table.HeaderCell>
          <Table.HeaderCell width={6}>Account</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {props.transactions.map(transaction => (
          <TransactionRow transaction={transaction} key={transaction.uuid} />
        ))}
        {props.transactions.length === 0 && (
          <Table.Row>
            <Table.Cell colSpan="4">
              {props.emptyText || "There are no transactions to show."}
            </Table.Cell>
          </Table.Row>
        )}
      </Table.Body>
    </Table>
  );
};

export default TransactionTable;



// WEBPACK FOOTER //
// ./frontend/src/components/TransactionTable.js